import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const RoutineIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <Path d="M10.0834 3.33337H16.75M0.75 3.04765L3.07726 5.33336L7.14997 1.33337M10.0833 12H16.7499M0.75 9.33334H6.08331V14.6667H0.75V9.33334Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

RoutineIcon.displayName = 'RoutineIcon';
